/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignBoxCenterStretch = createReactComponent(
  "align-box-center-stretch",
  "IconAlignBoxCenterStretch",
  [
    [
      "path",
      {
        d: "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M11 17h2", key: "svg-1" }],
    ["path", { d: "M9 12h6", key: "svg-2" }],
    ["path", { d: "M10 7h4", key: "svg-3" }]
  ]
);

export { IconAlignBoxCenterStretch as default };
//# sourceMappingURL=IconAlignBoxCenterStretch.js.map
